<script setup>
  import {
    ref,
    reactive,
    toRefs,
    onMounted,
    watch,
    nextTick,
    onUnmounted,
    computed,
    h,
  } from 'vue'
  import { message } from 'ant-design-vue'
  import { useRoute } from 'vue-router'
  import _ from 'lodash'
  import dayjs from 'dayjs'
  import {
    FileTextOutlined,
    DownOutlined,
    CheckCircleFilled,
  } from '@ant-design/icons-vue'
  import { useStore } from 'vuex'

  import {
    diffCompare,
    enginesList,
    getRecommendTwinslators,
    checkSourText,
    textTranslationNew,
    addScore,
    checkTextCalculate,
    getDocTranslateLib,
  } from '@/http/api'
  import { zhArr, enArr } from './index'
  import LanguageGroup from '../components/Language/LanguageGroup.vue'
  import AddTerms from '../components/AddTerms.vue'
  import AddDemoModal from './modal/AddDemoModal.vue'
  import TermModal from './MtModal/TermModal.vue'
  import CorpusModal from './MtModal/CorpusModal.vue'
  import aiMtView from '@/components/aiMt/index.vue'

  import calculateTextModal from '@/components/Modal/calculateTextModal.vue'
  const props = defineProps(['translateMode'])
  const route = useRoute()
  const query = route.query
  const flag = query?.type && query?.type == 'textTranslate'
  const isQianKun = window.__POWERED_BY_QIANKUN__

  const calculateTextRef = ref(null)
  const store = useStore()
  const enterpriseGlobalId = computed(() => store.state.comm.enterpriseGlobalId)
  const settingDetail = computed(() => store.state.comm.settingDetail)

  const state = reactive({
    checked: true,
    mtList: [], // 所有引擎
    companyMt: [], // 公司自研
    userMt: [], // 用户共建
    generalMt: [], // 通用引擎
    myMt: [], // 我的引擎
    aiMt: [], // 大模型
    twinslatorId: (flag && query?.twinslatorId) || null,
    chooseTwinslatorObj: {},
    recommendMtList: [],
    sourceLangId: (flag && query?.sourceLangId) || undefined,
    targetLangId: (flag && query?.targetLangId) || 2,
    translateLoading: false,
    translateResArr: [], // 译文所有结果
    translateRes: {}, // 当前译文结果
    visible: false,
    mtType: 1, // 1 垂直领域， 2 通用领域
    reduceScoreFlag: false,
    addScoreFlag: false,
    divInnerText: '',
    textDiv: null,
    reasonsVisible: false,
    scoreType: null,
    isShow: false,
    selectTarText: '',
    termList: [], // 添加的术语
    lock: false,
    selectIndex: '', // 译文选中下标
    demoIndex: 0,
    demoVisible: false,
    step: 1,
    description: '',
    reasonVisible: false,
    reasonBottomVisible: false,
    selectSourceText: '',
    leftAddShow: false,
    rightAddShow: false,
    termClecked: true, //应用术语库选择
    corpusChecked: true, //应用语料库选择
    termData: [], //术语库数据
    corpusData: [], //语料库数据
    defaultTerm: {},
    defaultCorpus: {},
    termVisible: false,
    corpusVisible: false,
  })

  const languageRef = ref(null)

  // 清空原文
  const clearInputTextFunc = () => {
    const dom = document.querySelector('.sent-textarea')
    dom.innerHTML = ''
    state.divInnerText = ''
    state.twinslatorId = null
    state.recommendMtList = []
    state.translateRes = {}
    state.chooseTwinslatorObj = {}
    state.reduceScoreFlag = true
    state.addScoreFlag = true
    state.leftAddShow = false
    state.rightAddShow = false
    getAllMtList()
  }

  // 获取全部引擎列表
  const getAllMtList = () => {
    return enginesList({
      sourceLangId: state.sourceLangId,
      targetLangId: state.targetLangId,
    }).then((res) => {
      const data = res.data.data
      state.mtList = data.list || []
      state.companyMt = state.mtList.filter((item) => item.type == 1)
      state.userMt = state.mtList.filter((item) => item.type == 2)
      state.generalMt = state.mtList.filter((item) => item.type == 3)
      state.myMt = state.mtList.filter((item) => item.type == 4)
      state.aiMt = state.mtList.filter((item) => item.type == 5)
      if (state.companyMt.length === 0 && state.userMt.length === 0) {
        state.mtType = 2
      }
      if (flag && query?.twinslatorId) {
        const arr = state.mtList.filter(
          (item) => item.twinslatorId == query?.twinslatorId
        )
        state.chooseTwinslatorObj = arr.length > 0 && arr[0]
      }
    })
  }

  //过滤文本文档html标签
  const xssFilter = (str) => {
    return str.replace(/<.*?>/g, '').replace(/\s+/g, ' ')
  }

  // 差异对比
  const diffCompareFunc = () => {
    state.translateResArr = state.translateResArr.map((item, index) => {
      return {
        ...item,
        target: index < 2 ? item.mtTarget : xssFilter(item.target),
        mtTarget: item.mtTarget || xssFilter(item.target),
      }
    })
    diffCompare({
      langId: state.targetLangId,
      list: state.translateResArr,
    }).then((res) => {
      const data = res.data.data
      state.translateResArr = data
      nextTick(() => {
        for (let i = 0; i < 100; i++) {
          const dom0 = document.getElementsByClassName(`light-${i}`)[0]
          const dom1 = document.getElementsByClassName(`light-${i}`)[1]
          dom0 &&
            dom0.addEventListener(
              'mouseenter',
              function () {
                dom1.style.background = 'rgba(255,200,20,0.4)'
              },
              false
            )
          dom0 &&
            dom0.addEventListener(
              'mouseleave',
              function () {
                // dom1.style.background = 'rgba(122, 89, 255, 0.1)'
                dom1.style.background = 'rgba(20, 200, 230, 0.2)'
              },
              false
            )
          dom1 &&
            dom1.addEventListener(
              'mouseenter',
              function () {
                dom0.style.background = 'rgba(255,200,20,0.4)'
              },
              false
            )
          dom1 &&
            dom1.addEventListener(
              'mouseleave',
              function () {
                // dom0.style.background = 'rgba(122, 89, 255, 0.1)'
                dom0.style.background = 'rgba(20, 200, 230, 0.2)'
              },
              false
            )
        }
      })
    })
  }

  // 获取翻译数据
  const getTransnlate = async (val) => {
    if (!state.divInnerText) return

    // console.log(val,props.translateMode,state.divInnerText,state.twinslatorId)
    //如果是开始翻译，或者勾选了实时翻译
    if (val || props.translateMode) {
      if (!state.twinslatorId) {
        message.warning('请选择引擎')
        return
      }
    } else {
      return
    }

    const {
      twinslatorId,
      sourceLangId,
      targetLangId,
      divInnerText: text,
      termList,
    } = state

    let payResult = await checkTextCalculate({ twinslatorId, text })

    let detailValue = payResult.data.data

    calculateTextRef.value.init(detailValue, () => {
      state.translateLoading = true
      return textTranslationNew({
        twinslatorId,
        sourceLangId,
        targetLangId,
        text,
        terms: JSON.stringify(termList),
        termLibraryId: state.termClecked
          ? state.defaultTerm?.library_id
          : undefined,
        corpusLibraryId: state.corpusChecked
          ? state.defaultCorpus?.library_id
          : undefined,
      })
        .then((res) => {
          const data = res.data.data
          state.translateLoading = false
          state.translateRes = data
          state.translateRes.mtTarget = data.target

          state.translateResArr = state.translateResArr.filter(
            (item) => item.target
          )
          const index = state.translateResArr.findIndex(
            (item) => item.twinslatorId == data.twinslatorId
          )
          if (index == -1) {
            state.translateResArr.unshift(data)
          } else {
            state.translateResArr.splice(index, 1)
            state.translateResArr.unshift(data)
          }
          state.translateResArr = state.translateResArr.map((item) => {
            return {
              addScoreFlag: false,
              reduceScoreFlag: false,
              ...item,
            }
          })
          state.reduceScoreFlag = false
          state.addScoreFlag = false

          // 光标移至最后
          let sentDom = document.querySelector('.sent-textarea')
          keepLastIndex(sentDom)

          // 是否勾选差异对比
          state.checked && state.translateResArr.length > 1 && diffCompareFunc()
          // 判断是否弹出提示窗
          const activeCurrentDate = localStorage.getItem('_activeCurrentDate')
          if (
            !activeCurrentDate ||
            dayjs().format('YYYY-MM-DD HH:mm:ss') > activeCurrentDate
          ) {
            // state.demoVisible = true
            localStorage._activeCurrentDate = dayjs()
              .add(1, 'days')
              .format('YYYY-MM-DD HH:mm:ss')
          } else {
            state.demoVisible = false
          }

          // 存储文本翻译原文译文，回显数据
          localStorage.setItem('_dbUserRes', JSON.stringify(state.translateRes))

          const dom = document.querySelector('.sent-textarea')
          let source = state.translateRes?.source
          dom.innerHTML = source
          keepLastIndexFunc(dom)
        })
        .catch(() => {
          state.translateLoading = false
        })
    })
  }

  // 点击引擎
  const chooseMt = (item, type) => {
    console.log('点击')
    if (type == 'all' && !item.support) return
    if (type == 'all') {
      state.chooseTwinslatorObj = item
    } else {
      state.chooseTwinslatorObj = {}
      state.addScoreFlag = false
      state.reduceScoreFlag = false
    }
    state.visible = false
    state.twinslatorId = item.twinslatorId
    console.log('执行')
    getTransnlate()
  }

  // 获取推荐引擎列表
  const getRecommendTwList = () => {
    if (!state.divInnerText) return
    if (settingDetail.value.native_engine_recommend_hidden === 'true') return
    return getRecommendTwinslators({
      sourceLangId: state.sourceLangId,
      targetLangId: state.targetLangId,
      text: state.divInnerText,
    })
      .then((res) => {
        const data = res.data.data
        state.recommendMtList = data.list || []
        if (
          state.recommendMtList.length > 0 &&
          JSON.stringify(state.chooseTwinslatorObj) == '{}'
        ) {
          state.twinslatorId = state.recommendMtList[0].twinslatorId
        }
        // if (state.twinslatorId) {
        //   const index = state.recommendMtList.findIndex(
        //     (item) => item.twinslatorId === state.twinslatorId
        //   )
        //   if (index == -1) {
        //     const list = state.mtList.filter(
        //       (item) => item.twinslatorId === state.twinslatorId
        //     )
        //     list.length > 0
        //       ? (state.chooseTwinslatorObj = list[0])
        //       : (state.chooseTwinslatorObj = {})
        //   } else {
        //     state.chooseTwinslatorObj = {}
        //   }
        // }
      })
      .catch(() => {
        state.recommendMtList = []
      })
  }

  // 光标移至最后一位
  const keepLastIndex = (obj) => {
    // if (window.getSelection) {
    //   //ie11 10 9 ff safari
    //   obj.focus() //解决ff不获取焦点无法定位问题
    //   var range = window.getSelection() //创建range
    //   range.selectAllChildren(obj) //range 选择obj下所有子内容
    //   range.collapseToEnd() //光标移至最后
    // } else if (document.selection) {
    //   //ie10 9 8 7 6 5
    //   var range = document.selection.createRange() //创建选择对象
    //   //var range = document.body.createTextRange();
    //   range.moveToElementText(obj) //range定位到obj
    //   range.collapse(false) //光标移至最后
    //   range.select()
    // }
  }

  // 光标移至最后一位
  const keepLastIndexFunc = (obj) => {
    if (window.getSelection) {
      //ie11 10 9 ff safari
      obj.focus() //解决ff不获取焦点无法定位问题
      var range = window.getSelection() //创建range
      range.selectAllChildren(obj) //range 选择obj下所有子内容
      range.collapseToEnd() //光标移至最后
    } else if (document.selection) {
      //ie10 9 8 7 6 5
      var range = document.selection.createRange() //创建选择对象
      //var range = document.body.createTextRange();
      range.moveToElementText(obj) //range定位到obj
      range.collapse(false) //光标移至最后
      range.select()
    }
  }

  // 输入框输入
  const changeTextFunc = _.debounce((event) => {
    if (state.lock) return
    state.leftAddShow = false
    state.rightAddShow = false
    const text = event.target.innerText
    state.divInnerText = text
    const len = event.target.innerText.length
    if (len > 5000) {
      event.preventDefault()
      event.target.innerText = event.target.innerText.substr(0, 5000)
      state.divInnerText = event.target.innerText
    }
    const obj = document.querySelector('.sent-textarea')
    keepLastIndex(obj)

    state.translateResArr = []

    if (!text) {
      state.translateRes = {}
      state.twinslatorId = null
      state.recommendMtList = []
      state.chooseTwinslatorObj = {}
      state.reduceScoreFlag = true
      state.addScoreFlag = true
      getAllMtList()
    } else {
      // 过滤enter键
      let replaceText = text.replace(/[\r\n]/g, '')
      if (!replaceText) {
        const dom = document.querySelector('.sent-textarea')
        dom.innerHTML = ''
        state.divInnerText = ''
        return
      }
      checkSourText({
        text: replaceText,
      }).then(async (res) => {
        const data = res.data.data
        if (!data.sourceLangId) {
          message.error('自动检测失败，请手动选择语种')
          return
        }
        state.sourceLangId = data.sourceLangId
        languageRef.value.srcLanguage = state.sourceLangId
        if (state.sourceLangId == 1) {
          state.targetLangId = 2
          languageRef.value.tarLanguage = 2
        } else {
          state.targetLangId = 1
          languageRef.value.tarLanguage = 1
        }
        await getRecommendTwList()
        if (props.translateMode) {
          // if (!state.chooseTwinslatorObj?.twinslatorId) {
          //   return message.warning('请选择引擎')
          // }
          await getTransnlate()
        }
        getAllMtList()
      })
    }
  }, 500)

  //复制链接
  const copyFunc = (target) => {
    var bodyElement = document.getElementsByTagName('body')[0]
    var selection = window.getSelection()
    var copyBlock = document.createElement('pre')
    copyBlock.style.position = 'absolute'
    copyBlock.style.top = '0'
    copyBlock.style.zIndex = '-99999'
    bodyElement.appendChild(copyBlock)
    copyBlock.innerHTML = target || ''
    selection.selectAllChildren(copyBlock)
    document.execCommand('Copy', false)
    copyBlock.remove()
    message.success({
      content: '复制成功',
      icon: h(CheckCircleFilled, { style: 'color: var(--primary-color)' }),
    })
  }

  // 删除
  const deleteFunc = (twinslatorId) => {
    const index = state.translateResArr.findIndex(
      (item) => item.twinslatorId == twinslatorId
    )
    state.translateResArr.splice(index, 1)
    if (state.translateResArr.length === 0) {
      getAllMtList()
    }
    state.checked && state.translateResArr.length > 1 && diffCompareFunc()
  }

  // 置顶
  const upFunc = (twinslatorId) => {
    const index = state.translateResArr.findIndex(
      (item) => item.twinslatorId == twinslatorId
    )
    const data = state.translateResArr.splice(index, 1)
    state.translateResArr = [...data, ...state.translateResArr]
    state.checked && state.translateResArr.length > 1 && diffCompareFunc()
  }

  // 赞踩评分,赞5分 踩1分  type 1 右上角译文评价  2 翻译结果评价
  const addScoreFunc = (item, score, type) => {
    state.scoreType = type
    if (score == 5) {
      item.addScoreFlag = true
      if (type == 1) {
        state.addScoreFlag = true
      }
    }
    if (score == 1) {
      state.step = 1
      state.description = ''
      return
    }
    addScore({
      score,
      twinslatorId: item.twinslatorId,
    })
  }

  // 清空所有
  const clearAllFunc = () => {
    state.translateResArr = []
    state.twinslatorId = null
    state.chooseTwinslatorObj = {}
  }

  // 取值
  const mathSource = () => {
    state.demoIndex++
    if (state.demoIndex >= 4) {
      state.demoIndex = 0
    }
  }

  const changeDemo = () => {
    const dom = document.querySelector('.sent-textarea')
    mathSource()
    state.translateResArr = []
    if (state.sourceLangId === 2) {
      dom.innerText = enArr[state.demoIndex]
    } else {
      dom.innerText = zhArr[state.demoIndex]
    }
    state.divInnerText = dom.innerText
    if (!dom.innerText) return
    checkSourText({
      text: dom.innerText,
    }).then(async (res) => {
      const data = res.data.data
      if (!data.sourceLangId) {
        message.error('自动检测失败，请手动选择语种')
        return
      }
      state.sourceLangId = data.sourceLangId
      //重置引擎选择
      state.chooseTwinslatorObj = {}
      languageRef.value.srcLanguage = state.sourceLangId
      if (state.sourceLangId == 2 && state.targetLangId == 2) {
        state.targetLangId = 1
        languageRef.value.tarLanguage = 1
      }
      if (state.sourceLangId == 1 && state.targetLangId == 1) {
        state.targetLangId = 2
        languageRef.value.tarLanguage = 2
      }

      getAllMtList()
      await getRecommendTwList()
      await getTransnlate()
    })
  }

  // 译文监听选中文本
  const selectionHandler = (item, key) => {
    const selection = window.getSelection()
    if (!selection) return
    if (selection.rangeCount <= 0) return
    const range = selection.getRangeAt(0)
    const rect = range.getBoundingClientRect()

    const dom = document.querySelector('.translate-res-box')
    const domRect = dom.getBoundingClientRect()

    if (!rect) return
    if (rect.width <= 0) return
    const wholeText = range.startContainer.wholeText
    const text = wholeText.slice(range.startOffset, range.endOffset)
    if (text.length > 0) {
      state.selectTarText = text
      state.leftAddShow = false

      if (state.isShow === false) {
        state.rightAddShow = true
      }

      // const box = document.querySelector('.right-add-box')
      // box.style.left = rect.left - domRect.left + 20 + 'px'
      // box.style.top = rect.top - domRect.top + 20 + 'px'
    }
  }

  // 监听原文选中文本
  const selectSourceHandler = () => {
    const selection = window.getSelection()
    if (!selection) return
    if (selection.rangeCount <= 0) return
    const range = selection.getRangeAt(0)
    const rect = range.getBoundingClientRect()

    const dom = document.querySelector('.sent-textarea')
    const domRect = dom.getBoundingClientRect()

    if (!rect) return
    if (rect.width <= 0) return
    const wholeText = range.startContainer.wholeText
    const text = wholeText.slice(range.startOffset, range.endOffset)
    const selectText = selection.toString()
    if (selection.toString().length > 0) {
      state.selectSourceText = selectText
      state.rightAddShow = false

      if (state.isShow === false) {
        state.leftAddShow = true
      }

      const box = document.querySelector('.left-add-box')
      box.style.left = rect.left - domRect.left + 'px'
      box.style.top = rect.top - domRect.top + 20 + 'px'
    }
  }

  const updateReason = (twinslatorId, description) => {
    state.reduceScoreFlag = true
    addScore({
      score: 1,
      twinslatorId,
      description,
    })
    state.scoreType == 2 &&
      state.translateResArr.forEach((item) => {
        if (item.twinslatorId == twinslatorId) {
          item.reduceScoreFlag = true
        }
      })
  }

  // 复制译文
  const copyTranslateText = () => {
    var bodyElement = document.getElementsByTagName('body')[0]
    var selection = window.getSelection()
    var copyBlock = document.createElement('pre')
    copyBlock.style.position = 'absolute'
    copyBlock.style.top = '0'
    copyBlock.style.zIndex = '-99999'
    bodyElement.appendChild(copyBlock)
    copyBlock.innerHTML = state.translateRes?.target
    selection.selectAllChildren(copyBlock)
    document.execCommand('Copy', false)
    copyBlock.remove()
    message.success({
      content: '复制成功',
      icon: h(CheckCircleFilled, { style: 'color: var(--primary-color)' }),
    })
  }

  // 根据language获取languageName
  const languageNameFunc = (id) => {
    const _languageList = JSON.parse(localStorage.getItem('languageInfoList'))
    if (!_languageList) return
    for (let i = 0; i < _languageList.length; i++) {
      if (_languageList[i].languageId == id) {
        return _languageList[i].languageName
      }
    }
  }

  // 分享
  const shareFunc = () => {
    var bodyElement = document.getElementsByTagName('body')[0]
    var selection = window.getSelection()
    var copyBlock = document.createElement('pre')
    copyBlock.style.position = 'absolute'
    copyBlock.style.top = '0'
    copyBlock.style.zIndex = '-99999'
    bodyElement.appendChild(copyBlock)
    const srcLanguageName = languageNameFunc(state.sourceLangId)
    const tarLanguageName = languageNameFunc(state.targetLangId)
    copyBlock.innerHTML +=
      '我正在使用TwinsMT【' +
      state.translateRes?.twinslatorName +
      '】翻译<br />' +
      '原文-' +
      srcLanguageName +
      '：' +
      state.divInnerText +
      '<br />' +
      '译文-' +
      tarLanguageName +
      '：' +
      state.translateRes?.target +
      '<br />' +
      '推荐你一起来用' +
      `${window.location.origin}/experience?type=textTranslate&sourceLangId=${state.sourceLangId}&targetLangId=${state.targetLangId}&twinslatorId=${state.twinslatorId}` +
      '<br />'
    selection.selectAllChildren(copyBlock)
    document.execCommand('Copy', false)
    copyBlock.remove()
    message.success({
      content: '翻译结果已复制，快去分享给朋友吧',
      icon: h(CheckCircleFilled, { style: 'color: var(--primary-color)' }),
    })
  }

  const updateTerms = (data) => {
    state.termList.push(...data)
    getTransnlate()
  }

  const addHoverStyle = (item, key) => {
    const dom = document.querySelector('.sent-textarea')
    let str = ''
    let sourceList = state.translateRes?.sourceList
    sourceList.forEach((item, index) => {
      const data = index == key ? 'item-hlight' : ''
      str += `<span class='${data}'>${item}</span>`
    })
    dom.innerHTML = str
    keepLastIndex(dom)
  }

  const removeHoverStyle = () => {
    const dom = document.querySelector('.sent-textarea')
    let source = state.translateRes?.source
    // console.log(state.translateRes.source);
    if (source === undefined) {
      return
    }
    dom.innerHTML = source
    keepLastIndex(dom)
  }

  const clearBtn = () => {
    document.body.onclick = function () {
      state.leftAddShow = false
      state.rightAddShow = false
    }
  }

  const showTermModal = () => {
    state.isShow = true
    state.leftAddShow = false
    state.rightAddShow = false
    removeHoverStyle()
  }

  // 判断是否有原文译文数据
  const preHandler = () => {
    const _dbUserRes = localStorage.getItem('_dbUserRes')
    if (
      _dbUserRes &&
      flag &&
      query?.sourceLangId &&
      query?.targetLangId &&
      query?.twinslatorId
    ) {
      const dbUserRes = JSON.parse(_dbUserRes)
      const dom = document.querySelector('.sent-textarea')
      dom.innerText = dbUserRes.sourse
      state.translateRes = dbUserRes
    }
  }

  const subFunc = (twinslatorId, description) => {
    if (!description) {
      message.error('请输入原因')
      return
    }
    state.description = description
    state.step = 3
    updateReason(twinslatorId, description)
  }

  // 切换语言
  const changeLanguage = async (v) => {
    state.targetLangId = v.tarLanguage
    state.sourceLangId = v.srcLanguage
    state.termList = []
    state.translateResArr = []
    //重置引擎选择
    state.chooseTwinslatorObj = {}
    state.defaultTerm = {}
    state.defaultCorpus = {}

    getAllMtList()
    await getRecommendTwList()
    await getTransnlate()
  }

  //展示术语弹窗
  const selectTermModal = () => {
    state.termVisible = true
  }
  //展示语料弹窗
  const showCorpusModal = () => {
    state.corpusVisible = true
  }

  const updateDefaultTerm = (libraryId) => {
    if (libraryId == -1) {
      state.defaultTerm = {}
      return
    }
    const list = state.termData.filter((item) => item.library_id === libraryId)
    state.defaultTerm = list.length > 0 ? list[0] : {}
  }

  const updateDefaultCorpus = (libraryId) => {
    if (libraryId == -1) {
      state.defaultCorpus = {}
      return
    }
    const list = state.corpusData.filter(
      (item) => item.library_id === libraryId
    )
    state.defaultCorpus = list.length > 0 ? list[0] : {}
  }

  // 获取库列表
  const getDocMtLibListFunc = () => {
    getDocTranslateLib({
      libType: 1,
      sourceLanguageId: state.sourceLangId || 1,
      targetLanguageId: state.targetLangId,
      langReverse: true,
      includeShare: false,
      includeCollect: false,
    }).then((res) => {
      let myList = res.data.data.myLibs || []
      let eList = res.data.data.enterpriseLibs || []
      myList.forEach((item) => {
        item.libType = 1
      })
      eList.forEach((item) => {
        item.libType = 2
      })
      const list = [...myList, ...eList]
      state.termData = list
    })
  }

  //获取语料库列表
  const getDocCorpusLibListFunc = () => {
    getDocTranslateLib({
      libType: 2,
      sourceLanguageId: state.sourceLangId || 1,
      targetLanguageId: state.targetLangId,
      langReverse: true,
      includeShare: false,
      includeCollect: false,
    }).then((res) => {
      let myList = res.data.data.myLibs || []
      let eList = res.data.data.enterpriseLibs || []
      myList.forEach((item) => {
        item.libType = 1
      })
      eList.forEach((item) => {
        item.libType = 2
      })
      const list = [...myList, ...eList]
      state.corpusData = list
    })
  }

  onMounted(() => {
    if (languageRef.value) {
      languageRef.value.srcLanguage = state.sourceLangId
      languageRef.value.tarLanguage = state.targetLangId
    }
    getAllMtList()
    clearBtn()
    preHandler()
    getDocMtLibListFunc()
    getDocCorpusLibListFunc()
  })

  watch(
    () => [state.sourceLangId, state.targetLangId],
    (n) => {
      getDocMtLibListFunc()
      getDocCorpusLibListFunc()
    }
  )

  watch(
    () => state.isShow,
    () => {
      state.leftAddShow = false
      state.rightAddShow = false
    }
  )

  const {
    checked,
    twinslatorId,
    recommendMtList,
    translateLoading,
    translateResArr,
    chooseTwinslatorObj,
    visible,
    mtType,
    translateRes,
    reduceScoreFlag,
    addScoreFlag,
    divInnerText,
    companyMt,
    userMt,
    generalMt,
    myMt,
    aiMt,
    isShow,
    selectTarText,
    sourceLangId,
    targetLangId,
    lock,
    demoVisible,
    step,
    description,
    reasonVisible,
    selectSourceText,
    leftAddShow,
    rightAddShow,
    termClecked, //应用术语库选择
    corpusChecked, //应用语料库选择
    termData, //术语库数据
    corpusData, //语料库数据
    defaultTerm,
    defaultCorpus,
    termVisible,
    corpusVisible,
  } = toRefs(state)
</script>

<template>
  <div class="text-page">
    <div class="display-flex margin-b-20">
      <div class="text-container">
        <div class="language-box flex-between margin-lr-20">
          <!-- 选择语言 -->
          <div class="flex-between">
            <div class="flex-align-center">
              <language-group
                @change="changeLanguage"
                ref="languageRef"
              ></language-group>
            </div>
          </div>
          <div class="flex-align-center">
            <div v-if="settingDetail.native_engine_recommend_hidden !== 'true'">
              <div
                class="flex-center margin-r-10"
                v-if="recommendMtList.length === 0"
              >
                <img
                  src="../../../images/ai-img.png"
                  alt=""
                  width="16"
                  height="16"
                />
                <span class="color-666 font-size-14 padding-l-6">
                  AI将为您智能推荐引擎
                </span>
              </div>
              <div class="flex-center margin-r-10" v-else>
                <img
                  src="../../../images/ai-img.png"
                  alt=""
                  width="16"
                  height="16"
                />
                <span class="color-666 font-size-14 padding-l-6 padding-r-10">
                  AI推荐引擎：
                </span>
                <div class="recommend-res flex-align-center">
                  <div
                    v-for="(item, key) in recommendMtList"
                    :key="key"
                    :class="[
                      'mt-item',
                      'cursor-pointer',
                      twinslatorId == item.twinslatorId ? 'mt-item-active' : '',
                    ]"
                    @click="chooseMt(item, 'recommend')"
                  >
                    <div>
                      <div class="flex-align-center">
                        <svg aria-hidden="true" class="icon">
                          <use :xlink:href="'#' + item.iconName"></use>
                        </svg>
                        <span
                          class="padding-l-8 height-16"
                          :title="item.twinslatorName"
                        >
                          {{ item.twinslatorName }}
                        </span>
                      </div>
                      <div class="mt-price">{{ item.price }}译力/千字</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <a-dropdown
              :trigger="['click']"
              placement="bottomRight"
              v-model:visible="visible"
            >
              <div
                class="choose-mt-box cursor-pointer flex-center"
                @click.prevent
                v-if="chooseTwinslatorObj?.twinslatorId"
              >
                <div>
                  <div class="flex-center">
                    <svg aria-hidden="true" class="icon">
                      <use
                        :xlink:href="'#' + chooseTwinslatorObj.iconName"
                      ></use>
                    </svg>
                    <span
                      style="height: 16px"
                      class="padding-l-8 padding-r-5 font-size-12"
                      :title="chooseTwinslatorObj.twinslatorName"
                    >
                      {{ chooseTwinslatorObj.twinslatorName }}
                    </span>
                  </div>
                  <div class="mt-price">
                    {{ chooseTwinslatorObj.price }}译力/千字
                  </div>
                </div>
                <DownOutlined class="font-size-12 padding-l-4" />
              </div>
              <div
                class="choose-mt-default-box flex-center cursor-pointer"
                @click.prevent
                v-else
              >
                <div>
                  <div class="text-center">
                    {{ recommendMtList.length > 0 ? '更多' : '全部引擎' }}
                    <DownOutlined class="font-size-12 padding-l-5" />
                  </div>
                </div>
              </div>
              <template #overlay>
                <div class="all-mt-box" @click.prevent>
                  <div class="mt-tabs display-flex">
                    <div
                      class="mt-tab flex-align-center margin-r-20"
                      :class="mtType == 1 && 'mt-tab-active'"
                      @click="mtType = 1"
                    >
                      垂直领域
                    </div>
                    <div
                      class="mt-tab flex-align-center margin-r-20"
                      :class="mtType == 2 && 'mt-tab-active'"
                      @click="mtType = 2"
                    >
                      通用领域
                    </div>
                    <div
                      class="mt-tab flex-align-center margin-r-20"
                      :class="mtType == 5 && 'mt-tab-active'"
                      @click="mtType = 5"
                    >
                      大模型
                    </div>
                    <div
                      v-if="myMt.length > 0"
                      class="mt-tab flex-align-center"
                      :class="mtType == 3 && 'mt-tab-active'"
                      @click="mtType = 3"
                    >
                      {{ enterpriseGlobalId == 'personal' ? '我的' : '企业' }}
                    </div>
                  </div>
                  <div class="mt-transn mt-common" v-if="mtType == 1">
                    <div class="display-flex">
                      <div
                        style="
                          width: 3px;
                          height: 12px;
                          background: var(--primary-color);
                          border-radius: 2px;
                          margin-top: 4px;
                        "
                      ></div>
                      <div
                        class="padding-l-10 padding-r-12 color-666 font-size-12"
                        style="line-height: 22px"
                      >
                        平台自研
                      </div>
                      <div class="display-flex flex-wrap flex-1">
                        <div
                          v-for="(item, key) in companyMt"
                          :key="key"
                          class="mt-choose-item margin-b-12 margin-r-15"
                          @click="chooseMt(item, 'all')"
                          v-if="companyMt.length > 0"
                        >
                          <div class="flex-center mt-icon-box">
                            <svg aria-hidden="true" class="icon">
                              <use :xlink:href="'#' + item.iconName"></use>
                            </svg>

                            <EngineTag :item="item"></EngineTag>
                          </div>
                          <div
                            class="text-center color-333 font-size-12 padding-t-6 white-1"
                            :title="item.twinslatorName"
                          >
                            {{ item.twinslatorName }}
                          </div>
                          <div class="mt-price">{{ item.price }}译力/千字</div>
                          <!-- 角标 -->
                          <div class="badge-box" v-if="item.iconType">
                            <img
                              src="../../../images/hot-mt-img.png"
                              v-if="item.iconType == 'HOT'"
                              alt=""
                            />
                            <img
                              src="../../../images/new-mt-img.png"
                              v-if="item.iconType == 'NEWEST'"
                              alt=""
                            />
                          </div>
                        </div>
                        <div v-else class="padding-l-20 font-size-12 color-999">
                          暂无数据
                        </div>
                      </div>
                    </div>
                    <div class="display-flex margin-t-12">
                      <div
                        style="
                          width: 3px;
                          height: 12px;
                          background: #00befa;
                          border-radius: 2px;
                          margin-top: 2px;
                        "
                      ></div>
                      <div
                        class="padding-l-10 padding-r-12 color-666 font-size-12"
                      >
                        联合共建
                      </div>
                      <div class="display-flex flex-wrap flex-1">
                        <div
                          v-for="(item, key) in userMt"
                          :key="key"
                          class="mt-choose-item margin-b-12 margin-r-15"
                          @click="chooseMt(item, 'all')"
                          v-if="userMt.length > 0"
                        >
                          <div class="flex-center mt-icon-box">
                            <svg aria-hidden="true" class="icon">
                              <use :xlink:href="'#' + item.iconName"></use>
                            </svg>
                            <EngineTag :item="item"></EngineTag>
                          </div>
                          <div
                            class="text-center color-333 font-size-12 padding-t-6 white-1"
                            :title="item.twinslatorName"
                          >
                            {{ item.twinslatorName }}
                          </div>
                          <div class="mt-price">{{ item.price }}译力/千字</div>
                        </div>
                        <div v-else class="padding-l-20 font-size-12 color-999">
                          暂无数据
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="mt-general mt-common" v-else-if="mtType == 2">
                    <div class="display-flex flex-wrap">
                      <div
                        v-for="(item, key) in generalMt"
                        :key="key"
                        class="mt-choose-item margin-b-12 margin-r-12"
                        @click="chooseMt(item, 'all')"
                        v-if="generalMt.length > 0"
                      >
                        <div class="flex-center mt-icon-box">
                          <EngineTag :item="item"></EngineTag>
                          <svg aria-hidden="true" class="icon">
                            <use :xlink:href="'#' + item.iconName"></use>
                          </svg>
                        </div>
                        <div
                          class="text-center color-333 font-size-12 padding-t-6 white-1"
                        >
                          {{ item.twinslatorName }}
                        </div>
                        <div class="mt-price">{{ item.price }}译力/千字</div>
                      </div>
                      <div v-else class="padding-l-20 font-size-12 color-999">
                        暂无数据
                      </div>
                    </div>
                  </div>
                  <div class="mt-general mt-common" v-else-if="mtType == 3">
                    <div class="display-flex flex-wrap">
                      <div
                        v-for="(item, key) in myMt"
                        :key="key"
                        class="mt-choose-item margin-b-12 margin-r-12"
                        @click="chooseMt(item, 'all')"
                        v-if="myMt.length > 0"
                      >
                        <div class="flex-center mt-icon-box">
                          <EngineTag :item="item"></EngineTag>
                          <svg aria-hidden="true" class="icon">
                            <use :xlink:href="'#' + item.iconName"></use>
                          </svg>
                        </div>
                        <div
                          class="text-center color-333 font-size-12 padding-t-6 white-1"
                        >
                          {{ item.twinslatorName }}
                        </div>
                        <div class="mt-price">{{ item.price }}译力/千字</div>
                      </div>
                      <div v-else class="padding-l-20 font-size-12 color-999">
                        暂无数据
                      </div>
                    </div>
                  </div>
                  <div class="mt-general mt-common" v-else-if="mtType == 5">
                    <aiMtView
                      v-model:parentVisible="visible"
                      :list="aiMt"
                      @onChange="chooseMt"
                      @get-list="getAllMtList"
                    />
                  </div>
                </div>
              </template>
            </a-dropdown>
          </div>
        </div>
        <div class="display-flex">
          <!-- 原文 -->
          <div class="input-box">
            <div class="input-text">
              <div
                class="sent-textarea"
                autofocus
                contenteditable
                placeholder="粘贴一段文字，体验引擎翻译效果，每次最多5000字。"
                placeholder2="您也可以选择下方行业案例文案尝试。"
                autocapitalize="off"
                spellcheck="false"
                @input="changeTextFunc"
                @compositionstart="lock = true"
                @compositionend="lock = false"
                @mouseup="selectSourceHandler"
                @click="(e) => e.stopPropagation()"
                :style="`padding-bottom:${props.translateMode ? 120 : 120}px`"
              ></div>
              <div
                style="
                  position: absolute;
                  bottom: 56px;
                  height: 40px;
                  left: 0;
                  right: 0;
                "
              >
                <div class="display-flex" @click.stop.native="() => {}">
                  <div class="flex-center">
                    <a-checkbox
                      v-model:checked="termClecked"
                      class="font-size-14"
                    >
                      术语
                    </a-checkbox>
                    <div
                      class="choose-term flex-align-center"
                      v-if="termClecked"
                      @click.stop="selectTermModal"
                    >
                      <div
                        class="color-bbb font-weight-400 font-size-14"
                        v-if="!defaultTerm?.library_name"
                      >
                        请选择术语库
                      </div>
                      <div
                        v-else
                        style="max-width: 180px"
                        class="white-1"
                        :title="defaultTerm?.library_name || ''"
                      >
                        {{ defaultTerm?.library_name }}
                      </div>
                      <DownOutlined class="down-icon" />
                    </div>
                  </div>
                  <div class="flex-center margin-l-15">
                    <a-checkbox
                      v-model:checked="corpusChecked"
                      class="font-size-14"
                    >
                      语料
                    </a-checkbox>
                    <div
                      class="choose-term flex-align-center"
                      v-if="corpusChecked"
                      @click.stop="showCorpusModal"
                    >
                      <div
                        class="color-bbb font-weight-400 font-size-14"
                        v-if="!defaultCorpus?.library_name"
                      >
                        请选择语料库
                      </div>
                      <div
                        v-else
                        style="max-width: 180px"
                        class="white-1"
                        :title="defaultCorpus?.library_name || ''"
                      >
                        {{ defaultCorpus?.library_name }}
                      </div>
                      <DownOutlined class="down-icon" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="count-box">
                {{ divInnerText.length }}/5000
                <a-button
                  v-show="!props.translateMode"
                  class="margin-l-20"
                  @click="getTransnlate(true)"
                  type="primary"
                >
                  开始翻译
                </a-button>
              </div>
              <div class="to-pe flex-align-center">
                <div
                  class="font-size-14 color-999 cursor-pointer margin-r-10 change-demo"
                  @click="changeDemo"
                >
                  <svg
                    aria-hidden="true"
                    class="icon"
                    style="width: 16px; height: 16px"
                  >
                    <use xlink:href="#icon-shuaxin"></use>
                  </svg>
                  <span class="padding-l-5">
                    {{ divInnerText.length > 0 ? '换个例子' : '试试行业案例' }}
                  </span>
                </div>
              </div>
              <div
                class="clear-icon flex-center margin-l-20"
                v-if="divInnerText"
                @click="clearInputTextFunc"
              >
                <svg aria-hidden="true" class="icon">
                  <use xlink:href="#icon-qingchu"></use>
                </svg>
              </div>
            </div>
          </div>
          <!-- 译文 -->
          <div class="translate-res padding-lr-20 padding-b-20">
            <div v-if="translateRes?.target" class="translate-res-box">
              <div @click="(e) => e.stopPropagation()" class="translate-text">
                <span
                  v-for="(item, key) in translateRes?.targetList"
                  :key="key"
                  class="item-hover"
                  @mouseup="selectionHandler"
                  @mouseenter="addHoverStyle(item, key)"
                  @mouseleave="removeHoverStyle"
                >
                  {{ item }}
                </span>
              </div>
              <p
                class="color-bbb font-size-14 padding-b-40"
                v-if="translateRes?.modelDesc"
              >
                该翻译来自{{ translateRes?.modelDesc }}
              </p>
              <!-- <div
                class="right-add-box"
                v-show="rightAddShow"
                @click="showTermModal"
              >
                <svg aria-hidden="true" class="icon">
                  <use xlink:href="#icon-tianjia"></use>
                </svg>
                <span class="padding-l-10">添加术语</span>
              </div> -->
            </div>
            <div class="color-bbb font-size-14 padding-t-20" v-else>译文</div>
            <div
              class="translate-footer flex-between"
              v-if="translateRes?.target"
            >
              <div class="display-flex">
                <div class="flex-center copy-box" @click="copyTranslateText">
                  <svg aria-hidden="true" class="icon">
                    <use xlink:href="#icon-fuzhi"></use>
                  </svg>
                  <span class="color-999 font-size-14 padding-l-5">复制</span>
                </div>
                <div
                  class="flex-center share-box margin-l-10"
                  @click="shareFunc"
                  v-if="!isQianKun"
                >
                  <svg aria-hidden="true" class="icon">
                    <use xlink:href="#icon-fenxiang"></use>
                  </svg>
                  <span class="color-999 font-size-14 padding-l-5">分享</span>
                </div>
              </div>
              <div class="display-flex">
                <div class="flex-center">
                  <span class="color-999 font-size-14">译的如何？</span>
                  <div
                    class="margin-l-20 margin-r-12 icon-box"
                    :class="reduceScoreFlag && 'visibility-hidden'"
                  >
                    <svg
                      aria-hidden="true"
                      class="icon"
                      @click="addScoreFunc(translateRes, 5, 1)"
                      v-if="!addScoreFlag"
                    >
                      <use xlink:href="#icon-zan0"></use>
                    </svg>
                    <svg aria-hidden="true" class="icon" v-else>
                      <use xlink:href="#icon-zan1"></use>
                    </svg>
                  </div>

                  <a-dropdown
                    trigger="click"
                    v-model:visible="reasonVisible"
                    :class="addScoreFlag && 'visibility-hidden'"
                  >
                    <template #overlay>
                      <div class="reason-box">
                        <div v-if="step === 1">
                          <p class="color-333 font-size-14">
                            该句翻译有何问题？
                          </p>
                          <div
                            class="reason-item margin-t-16"
                            @click="
                              subFunc(translateRes?.twinslatorId, '语法错误')
                            "
                          >
                            语法错误
                          </div>
                          <div
                            class="reason-item"
                            @click="
                              subFunc(
                                translateRes?.twinslatorId,
                                '术语翻译错误'
                              )
                            "
                          >
                            术语翻译错误
                          </div>
                          <div
                            class="reason-item"
                            @click="subFunc(translateRes?.twinslatorId, '漏译')"
                          >
                            漏译
                          </div>
                          <div
                            class="reason-item"
                            @click="
                              subFunc(translateRes?.twinslatorId, '翻译不连贯')
                            "
                          >
                            翻译不连贯
                          </div>
                          <div class="reason-item" @click="step = 2">其他</div>
                        </div>
                        <div v-else-if="step === 2">
                          <p class="color-333 font-size-14">用户反馈</p>
                          <div class="description-title"></div>
                          <div class="reason-textarea">
                            <a-textarea
                              v-model:value="description"
                              placeholder="请输入原因"
                              :maxlength="300"
                              class="sent-textarea"
                              autofocus
                            />
                            <div class="count-box">
                              {{ description.length }}/300
                            </div>
                            <div class="sub-box">
                              <a-button
                                type="primary"
                                @click="
                                  subFunc(
                                    translateRes?.twinslatorId,
                                    description
                                  )
                                "
                              >
                                提交
                              </a-button>
                            </div>
                          </div>
                        </div>
                        <div v-else class="margin-t-50 margin-r-10">
                          <div class="img-box">
                            <img
                              src="../../../images/sub-success-img.png"
                              alt=""
                            />
                          </div>
                          <div
                            class="text-center color-333 font-size-14 margin-t-15 margin-b-8"
                          >
                            <p>感谢您的反馈</p>
                            <p>我们会持续努力</p>
                          </div>
                          <div class="close-box">
                            <a-button @click="reasonVisible = false">
                              关闭
                            </a-button>
                          </div>
                        </div>
                        <div
                          class="icon-reason-close"
                          @click="reasonVisible = false"
                        >
                          <svg
                            aria-hidden="true"
                            style="height: 8px; width: 8px"
                          >
                            <use xlink:href="#icon-guanbi"></use>
                          </svg>
                        </div>
                      </div>
                    </template>
                    <div class="icon-box">
                      <svg
                        aria-hidden="true"
                        class="icon"
                        @click="addScoreFunc(translateRes, 1, 1)"
                        v-if="!reduceScoreFlag"
                      >
                        <use xlink:href="#icon-cai0"></use>
                      </svg>
                      <svg aria-hidden="true" class="icon" v-else>
                        <use xlink:href="#icon-cai1"></use>
                      </svg>
                    </div>
                  </a-dropdown>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 翻译结果 -->
    <div class="result-box" v-if="translateResArr.length > 0">
      <div class="result-title flex-between">
        <div class="color-333 font-weight-600">翻译结果</div>
        <div class="flex-align-center">
          <div class="color-333 padding-r-10 font-size-14">差异对比</div>
          <a-switch v-model:checked="checked" />
          <!-- <div
            class="flex-center padding-l-20"
            v-if="checked && translateResArr.length > 1"
          >
            <div class="color-tips-box bg-15cde6"></div>
            <div class="color-999 font-size-12 padding-l-10 padding-r-20">
              可对比
            </div>
            <div class="color-tips-box bg-7a59ff"></div>
            <div class="color-999 font-size-12 padding-l-10">无对应</div>
          </div> -->
          <div class="flex-center empty-box margin-l-30">
            <svg aria-hidden="true" class="icon">
              <use xlink:href="#icon-qingkong"></use>
            </svg>
            <span
              class="font-size-14 padding-l-10 user-select-none"
              @click="clearAllFunc"
            >
              清空所有
            </span>
          </div>
        </div>
      </div>
      <div class="result-container">
        <div v-for="(item, key) in translateResArr" :key="key">
          <div
            class="result-list display-flex"
            :class="
              checked &&
              translateResArr.length >= 2 &&
              key <= 1 &&
              'checked-result-list-' + key
            "
          >
            <div class="mt-name">
              <svg aria-hidden="true" class="icon">
                <use :xlink:href="'#' + item.iconName"></use>
              </svg>
              <span class="padding-l-8">{{ item.twinslatorName }}</span>
            </div>
            <div class="mt-res" v-if="!item.target">
              <span class="color-bbb">译文结果</span>
            </div>
            <div class="mt-res">
              <a-button
                shape="circle"
                loading
                class="mt-loading"
                v-if="item.target && translateLoading && key === 0"
              />
              <div
                v-else
                v-html="checked ? item.target : item.mtTarget || item.target"
              ></div>
            </div>
            <div class="mt-appraise" v-if="item.target">
              <div class="display-flex justify-between">
                <div class="icon-box">
                  <svg
                    aria-hidden="true"
                    class="icon"
                    @click="copyFunc(item.mtTarget || item.target)"
                  >
                    <use xlink:href="#icon-fuzhi"></use>
                  </svg>
                </div>
                <div class="icon-box">
                  <svg
                    aria-hidden="true"
                    class="icon"
                    @click="deleteFunc(item.twinslatorId)"
                  >
                    <use xlink:href="#icon-shanchu"></use>
                  </svg>
                </div>
              </div>
              <div class="display-flex justify-between">
                <div
                  class="icon-box"
                  :class="item.reduceScoreFlag && 'visibility-hidden'"
                >
                  <svg
                    aria-hidden="true"
                    class="icon"
                    @click="addScoreFunc(item, 5, 2)"
                    v-if="!item.addScoreFlag"
                  >
                    <use xlink:href="#icon-zan0"></use>
                  </svg>
                  <svg aria-hidden="true" class="icon" v-else>
                    <use xlink:href="#icon-zan1"></use>
                  </svg>
                </div>
                <a-dropdown
                  trigger="click"
                  v-model:visible="item.modelDesc1"
                  :class="item.addScoreFlag && 'visibility-hidden'"
                >
                  <template #overlay>
                    <div class="reason-box">
                      <div v-if="step === 1">
                        <p class="color-333 font-size-14">该句翻译有何问题？</p>
                        <div
                          class="reason-item margin-t-16"
                          @click="subFunc(item.twinslatorId, '语法错误')"
                        >
                          语法错误
                        </div>
                        <div
                          class="reason-item"
                          @click="subFunc(item.twinslatorId, '术语翻译错误')"
                        >
                          术语翻译错误
                        </div>
                        <div
                          class="reason-item"
                          @click="subFunc(item.twinslatorId, '漏译')"
                        >
                          漏译
                        </div>
                        <div
                          class="reason-item"
                          @click="subFunc(item.twinslatorId, '翻译不连贯')"
                        >
                          翻译不连贯
                        </div>
                        <div class="reason-item" @click="step = 2">其他</div>
                      </div>
                      <div v-else-if="step === 2">
                        <p class="color-333 font-size-14">用户反馈</p>
                        <div class="description-title"></div>
                        <div class="reason-textarea">
                          <a-textarea
                            v-model:value="description"
                            placeholder="请输入原因"
                            :maxlength="300"
                            class="sent-textarea"
                            autofocus
                          />
                          <div class="count-box">
                            {{ description.length }}/300
                          </div>
                          <div class="sub-box">
                            <a-button
                              type="primary"
                              @click="subFunc(item.twinslatorId, description)"
                            >
                              提交
                            </a-button>
                          </div>
                        </div>
                      </div>
                      <div v-else class="margin-t-50 margin-r-10">
                        <div class="img-box">
                          <img
                            src="../../../images/sub-success-img.png"
                            alt=""
                          />
                        </div>
                        <div
                          class="text-center color-333 font-size-14 margin-t-15 margin-b-8"
                        >
                          <p>感谢您的反馈</p>
                          <p>我们会持续努力</p>
                        </div>
                        <div class="close-box">
                          <a-button @click="item.modelDesc1 = null">
                            关闭
                          </a-button>
                        </div>
                      </div>
                      <div
                        class="icon-reason-close"
                        @click="item.modelDesc1 = null"
                      >
                        <svg aria-hidden="true" style="height: 8px; width: 8px">
                          <use xlink:href="#icon-guanbi"></use>
                        </svg>
                      </div>
                    </div>
                  </template>
                  <div class="icon-box">
                    <svg
                      aria-hidden="true"
                      class="icon"
                      @click="addScoreFunc(item, 1, 2)"
                      v-if="!item.reduceScoreFlag"
                    >
                      <use xlink:href="#icon-cai0"></use>
                    </svg>
                    <svg aria-hidden="true" class="icon" v-else>
                      <use xlink:href="#icon-cai1"></use>
                    </svg>
                  </div>
                </a-dropdown>
              </div>
              <!-- 置顶图标 -->
              <div
                class="mt-up flex-center"
                :class="item.mtTarget.length > 100 && 'mt-up-high'"
                v-if="checked && translateResArr.length > 2 && key >= 2"
                @click="upFunc(item.twinslatorId)"
              >
                <a-tooltip>
                  <template #title>将该句置顶对比</template>
                  <svg aria-hidden="true" class="icon">
                    <use xlink:href="#icon-xingzhuangjiehe"></use>
                  </svg>
                  <span class="margin-l-5 font-size-12 color-333">对比</span>
                </a-tooltip>
              </div>
            </div>
          </div>
          <div
            v-if="checked && translateResArr.length > 2 && key == 1"
            class="text-center color-bbb font-size-14 padding-tb-20"
          >
            ——
            &nbsp;&nbsp;差异对比仅支持前2条对比，想对比下方结果请点击右侧“置顶”按钮&nbsp;&nbsp;
            ——
          </div>
        </div>
      </div>
    </div>
  </div>

  <!--  &lt;!&ndash; 添加术语 &ndash;&gt;-->
  <!--  <AddTerms-->
  <!--    v-if="isShow"-->
  <!--    type="text"-->
  <!--    @updateTerms="updateTerms"-->
  <!--    v-model:isShow="isShow"-->
  <!--    :sourceLangId="sourceLangId"-->
  <!--    :targetLangId="targetLangId"-->
  <!--    v-model:selectTarText="selectTarText"-->
  <!--    v-model:selectSourceText="selectSourceText"-->
  <!--  />-->

  <!--  &lt;!&ndash; 添加术语示例 &ndash;&gt;-->
  <!--  <AddDemoModal v-model:demoVisible="demoVisible" />-->

  <calculateTextModal
    ref="calculateTextRef"
    :mtDetail="chooseTwinslatorObj"
  ></calculateTextModal>

  <!-- 术语列表弹窗 -->
  <TermModal
    v-model:termVisible="termVisible"
    :termData="termData"
    :libId="defaultTerm.library_id"
    @updateDefaultTerm="updateDefaultTerm"
  />

  <!--语料列表弹窗-->
  <CorpusModal
    v-model:corpusVisible="corpusVisible"
    :corpusData="corpusData"
    :libId="defaultCorpus.library_id"
    @updateDefaultCorpus="updateDefaultCorpus"
  ></CorpusModal>
</template>

<style lang="scss" scoped>
  .mt-price {
    font-size: 12px;
    color: #bbb;
    text-align: center;
  }
  .text-page {
    padding-bottom: 20px;
    .text-container {
      width: 100%;
      min-height: 460px;
      background-color: #fff;
      box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.04);
      border: 1px solid #f2f3f5;
      border-radius: 8px;
    }
    .input-box {
      width: 600px;
      min-height: 400px;
      padding: 0 20px;
      background-color: #fff;
      border-right: 1px solid #f2f3f5;
      border-radius: 0 0 0 8px;
    }
    .language-box {
      font-size: 14px;
      height: 58px;
      border-bottom: 1px solid #f2f3f5;
    }
    .input-text {
      position: relative;
      height: 100%;
      .sent-textarea {
        padding: 20px 10px 50px 0;
        word-break: break-word;
        position: relative;
        font-size: 14px;
        &:empty:before {
          content: attr(placeholder);
          color: #999;
        }
        &:empty:after {
          position: absolute;
          top: 40px;
          left: 0;
          content: attr(placeholder2);
          color: #999;
        }
      }
      :deep(textarea) {
        height: 100%;
        padding: 20px 0 0 0;
        border: 0;
        resize: none !important;
        outline: none;
        box-shadow: none;
        &::-webkit-scrollbar {
          width: 6px;
          height: 6px;
          background-color: transparent;
        }
        &::-webkit-scrollbar-thumb {
          max-height: 10px;
          min-width: 6px;
          border-radius: 6px;
          -webkit-box-shadow: inset 0 0 6px #888;
          position: relative;
        }
        &::-webkit-scrollbar-track {
          width: 6px;
          height: 6px;
          // background-color: #aaa;
        }
      }
      :deep(.item-hlight) {
        background: rgba(122, 89, 255, 0.2);
      }
      .count-box {
        position: absolute;
        right: 0;
        bottom: 24px;
        font-size: 12px;
        color: #bbb;
      }
      .to-pe {
        position: absolute;
        bottom: 14px;
        left: 0;
      }
      .change-demo,
      .to-translate {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 128px;
        height: 32px;
        border-radius: 6px;
        &:hover {
          background: #f2f3f5;
        }
        span {
          height: 16px;
          line-height: 16px;
        }
      }
      .to-translate {
        width: 100px;
      }
      .placeholder-box {
        position: absolute;
        top: 20px;
        left: 2px;
        color: #bbb;
      }
    }
    .translate-res {
      position: relative;
      width: 599px;
      min-height: 400px;
      padding-bottom: 30px;
      border-radius: 0 0 8px 0;
      .translate-res-box {
        .translate-text {
          position: relative;
          padding-top: 20px;
          padding-bottom: 40px;
          word-break: break-word;
          .item-hover {
            position: relative;
            &:hover {
              background: rgba(122, 89, 255, 0.2);
            }
            .add-term-btn {
              display: flex;
              justify-content: center;
              align-items: center;
              position: absolute;
              z-index: 1;
              left: 0;
              bottom: -40px;
              height: 40px;
              width: 112px;
              background: #fff;
              box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.2);
              border-radius: 6px;
              cursor: pointer;
            }
          }
        }
      }
      .translate-footer {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 20px;
        //height: 30px;
        padding: 0 20px;
      }
    }
    .choose-term {
      position: relative;
      width: 150px;
      height: 32px;
      padding-left: 16px;
      padding-right: 32px;
      background: #fff;
      border-radius: 20px;
      border: 1px solid #edeeef;
      cursor: pointer;
      .down-icon {
        position: absolute;
        right: 16px;
        bottom: 4px;
        width: 16px;
        height: 16px;
        font-size: 10px;
        color: #333;
      }
    }

    .tw-box {
      width: 416px;
      height: 338px;
      padding: 0 10px 0 30px;
      background-color: #f3f1ff;
      border-radius: 8px;
    }
    .recommend-title,
    .mt-title {
      height: 58px;
    }
    .recommend-res {
      height: 32px;
    }
    .mt-item {
      display: flex;
      align-items: center;
      padding: 4px 14px;
      color: #333;
      font-size: 13px;
      background: #fff;
      border-radius: 6px;
      margin-right: 8px;
      user-select: none;
      border: 1px solid #edeeef;
      &:hover {
        border: 1px solid var(--primary-color);
      }
    }
    .mt-item-active {
      background: #f6faff;
      border: 2px solid var(--primary-color);
      &:hover {
        background: #f6faff;
        border: 2px solid var(--primary-color);
      }
    }

    .result-box {
      // padding: 0 20px;
      background: #fff;
      border-radius: 8px;
      border: 1px solid #f2f3f5;
    }
    .result-title {
      height: 58px;
      padding: 0 20px;
    }
    .icon {
      width: 16px;
      height: 16px;
      vertical-align: middle;
      cursor: pointer;
      flex-shrink: 0;
    }
    .icon-box {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 24px;
      height: 24px;
      border-radius: 4px;
      &:hover {
        background: #f2f3f5;
      }
    }
    .empty-box {
      width: 112px;
      height: 32px;
      border-radius: 6px;
      color: #bbb;
      .icon {
        opacity: 0.3;
      }
      &:hover {
        background: #f2f3f5;
        cursor: pointer;
        color: #333;
        .icon {
          opacity: 1;
        }
      }
    }
    .result-list {
      border-top: 1px solid #f2f3f5;
      min-height: 120px;
      padding: 20px 20px;
    }
    .checked-result-list-0 {
      background: #f9f8ff;
      border: 1px solid #c8baff;
      border-radius: 8px 8px 0 0;
      border-bottom: 0;
    }
    .checked-result-list-1 {
      background: #f9f8ff;
      border: 1px solid #c8baff;
      border-radius: 0 0 8px 8px;
      border-top: 1px solid #f2f3f5;
    }
    .mt-name {
      display: flex;
      // align-items: center;
      position: relative;
      width: 126px;
      height: 22px;
      flex-shrink: 0;
      padding-right: 5px;
      svg {
        flex-shrink: 0;
        margin-top: 3px;
      }
      &::after {
        position: absolute;
        right: 0;
        top: 0;
        bottom: 0;
        width: 0;
        border-right: 1px solid #f2f3f5;
        content: '';
      }
    }
    .mt-res {
      padding: 0 20px;
      flex: 1;
      word-break: break-word;
      :deep(.peadd) {
        background: rgba(122, 89, 255, 0.1);
      }
      :deep(.pedelete) {
        color: #bbb;
        display: none;
      }
      :deep(.mtdelete) {
        color: #bbb;
      }
      :deep(.mtadd) {
        background: rgba(122, 89, 255, 0.1);
      }
    }
    .mt-appraise {
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      flex-shrink: 0;
      width: 60px;
    }
    .mt-up {
      position: absolute;
      right: 0;
      top: 28px;
      width: 60px;
      height: 24px;
      cursor: pointer;
      border-radius: 4px;
      border: 1px solid #edeeef;
      .icon {
        width: 9px;
        height: 9px;
      }
      &:hover {
        border: 1px solid #ded6ff;
      }
    }
    .mt-up-high {
      top: 36px;
    }

    // :deep(.ant-switch) {
    //     min-width: 32px;
    // }
    :deep(.ant-switch-checked) {
      background-color: #000;
    }
    :deep(.ant-switch:focus) {
      box-shadow: none;
    }
    .bg-f3f1ff {
      background-color: #f3f1ff;
    }
    .class-calc-100 {
      height: calc(100% - 58px);
    }
    .class-calc-80 {
      height: calc(100% - 88px - 58px);
    }
    .color-9e87f9 {
      color: #9e87f9;
    }
    .color-7a59ff {
      color: var(--primary-color);
    }
    .color-bbb {
      color: #bbb;
    }
    .flex-wrap {
      flex-wrap: wrap;
    }
    .mt-disabled {
      opacity: 0.2;
      cursor: not-allowed;
    }
    .recommend-loading {
      width: 32px;
      height: 32px;
      color: #554df2;
      background: #fff;
      border: none;
      text-shadow: none;
      box-shadow: none;
      margin-left: 16px;
    }
    .mt-loading {
      width: 32px;
      height: 32px;
      color: #554df2;
      background: #fff;
      border: none;
      text-shadow: none;
      box-shadow: none;
    }
    .clear-icon {
      position: absolute;
      top: 0;
      right: -18px;
      width: 32px;
      height: 32px;
      border-radius: 6px;
      .icon {
        fill: #ddd;
      }
      &:hover {
        .icon {
          fill: #000;
        }
      }
    }
    .width-170 {
      width: 170px;
    }
    .width-540 {
      width: 360px;
    }
    .choose-mt-default-box {
      min-width: 104px;
      height: 44px;
      background: #fff;
      color: #333;
      font-size: 14px;
      border-radius: 6px;
      border: 1px solid #edeeef;
      &:hover {
        border: 1px solid var(--primary-color);
      }
    }
    .choose-mt-box {
      padding: 2px 14px;
      //height: 32px;
      height: 44px;
      background: #fff;
      border-radius: 6px;
      border: 1px solid var(--primary-color);
    }
  }
  .all-mt-box {
    width: 500px;
    height: 340px;
    background: #fff;
    box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    border: 1px solid #f2f3f5;
    .mt-tabs {
      height: 48px;
      padding: 0 20px 0 30px;
      border-bottom: 1px solid #f2f3f5;
    }
    .mt-tab {
      color: #000;
      font-size: 14px;
      height: 100%;
      cursor: pointer;
    }
    .mt-tab-active {
      position: relative;
      font-weight: 600;
      &::after {
        position: absolute;
        right: 0;
        left: 0;
        bottom: 0;
        height: 2px;
        background: #333;
        content: '';
      }
    }
    .mt-common {
      padding: 20px 0 20px 20px;
      height: calc(100% - 48px);
      overflow-y: auto;
      &::-webkit-input-placeholder {
        font-size: 14px;
        color: #818385;
      }
      &::-webkit-scrollbar {
        width: 7px;
        background-color: rgba(0, 0, 0, 0);
      }
      &::-webkit-scrollbar-thumb {
        background: #bfbfbf;
        border-radius: 10px;
        width: 7px;
      }
    }
    .mt-choose-item {
      position: relative;
      //height: 90px;
      width: 74px;
      cursor: pointer;
      &:hover {
        .icon {
          width: 20px;
          height: 20px;
        }
      }
    }
    .mt-icon-box {
      width: 48px;
      height: 48px;
      background: #f5f5f5;
      border-radius: 50%;
      margin: 0 auto;
      position: relative;
      .icon {
        width: 20px;
        height: 20px;
        vertical-align: middle;
        cursor: pointer;
      }
    }
  }
  .flex-wrap {
    flex-wrap: wrap;
  }
  .copy-box,
  .share-box {
    width: 72px;
    height: 32px;
    background: #fff;
    cursor: pointer;
    &:hover {
      background: #f2f3f5;
      border-radius: 6px;
    }
  }
  .badge-box {
    position: absolute;
    top: 0;
    right: 0;
    width: 24px;
    height: 12px;
    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }

  .reason-box {
    position: relative;
    width: 200px;
    box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    padding: 20px;
    background-color: #fff;
    .icon-reason-close {
      position: absolute;
      right: 20px;
      top: 18px;
      width: 24px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      &:hover {
        background-color: #f2f3f5;
        cursor: pointer;
      }
    }
    .reason-item {
      display: flex;
      width: 160px;
      height: 32px;
      color: #333;
      font-size: 14px;
      align-items: center;
      padding-left: 20px;
      border-radius: 20px;
      border: 1px solid #edeeef;
      background: #fff;
      margin-bottom: 10px;
      cursor: pointer;
      &:hover {
        border: 1px solid #ded6ff;
      }
    }
    .description-title {
      margin-top: 10px;
      margin-right: 24px;
      height: 1px;
      background-color: #edeeef;
    }
    .count-box {
      text-align: right;
      margin-right: 10px;
    }
    .reason-textarea {
      textarea {
        height: 140px;
        padding: 20px 0 0 0;
        border: 0;
        resize: none !important;
        outline: none;
        box-shadow: none;
        &::-webkit-scrollbar {
          width: 6px;
          height: 6px;
          background-color: transparent;
        }
        &::-webkit-scrollbar-thumb {
          max-height: 10px;
          min-width: 6px;
          border-radius: 6px;
          -webkit-box-shadow: inset 0 0 6px #888;
          position: relative;
        }
        &::-webkit-scrollbar-track {
          width: 6px;
          height: 6px;
          // background-color: #aaa;
        }
      }
    }
    .sub-box {
      margin-left: 90px;
      margin-top: 12px;
    }
    .close-box {
      margin-left: 90px;
      margin-top: 50px;
    }
    .img-box {
      width: 56px;
      height: 56px;
      margin: 0 auto;
      img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
  }
  .sent-textarea {
    :deep(.source-text-box) {
      position: relative;
      word-break: break-all;
    }
    :deep(.add-term-btn) {
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      z-index: 1;
      left: 0;
      bottom: -40px;
      height: 40px;
      width: 112px;
      background: #fff;
      box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.2);
      border-radius: 6px;
      cursor: pointer;
    }
  }
  .left-add-box,
  .right-add-box {
    position: absolute;
    z-index: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 40px;
    width: 112px;
    background: #fff;
    box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.2);
    border-radius: 6px;
    cursor: pointer;
    .icon {
      float: left;
      width: 16px;
      height: 16px;
    }
    span {
      float: right;
      height: 16px;
      line-height: 16px;
    }
  }
  .height-16 {
    height: 16px;
    line-height: 16px;
  }
  .color-tips-box {
    width: 12px;
    height: 12px;
    opacity: 0.2;
  }
  .bg-7a59ff {
    background: var(--primary-color);
  }
  .bg-15cde6 {
    background: #15cde6;
  }
  @for $i from 0 to 50 {
    :deep(.light-#{$i}) {
      padding: 2px 0 2px 0;
      font-weight: 600;
      // background: rgba(122, 89, 255, 0.1);
      background: rgba(20, 200, 230, 0.2);
      &:hover {
        background: rgba(255, 200, 20, 0.4) !important;
        cursor: pointer;
      }
    }
    :deep(.add-src-#{$i}) {
      padding: 2px 0 2px 0;
      font-weight: 600;
      // background: rgba(20, 200, 230, 0.2);
      background: rgba(122, 89, 255, 0.1);
    }
    :deep(.add-tgt-#{$i}) {
      padding: 2px 0 2px 0;
      font-weight: 600;
      // background: rgba(20, 200, 230, 0.2);
      background: rgba(122, 89, 255, 0.1);
    }
  }
  :deep(.f-term) {
    color: #00b27d;
  }
  :deep(.f-term2) {
    color: #64be04;
  }
</style>
